﻿(function (angular, dataLayer) {
  "use strict";

  angular.module("Toyota.Factories").factory("PricingPageAnalyticsService", [
    "$analytics",
    "Range",
    function ($analytics, Range) {
      // Managed state of current vehicle and options.
      var vehicleGrade = {};
      var vehicleVariants = {};
      var vehicleExtras = {};
      var vehicleTrim = {};
      var vehicleBodyPaint = {};
      var vehicleRoofPaint = {};

      var vehicleFinanceSetting = "cash";
      var vehicleDriveawayPrice = {};
      var vehicleFinanceOptions = {};

      function getAllVehicleData() {
        var vehicleData = angular.extend(
          {},
          vehicleGrade,
          vehicleVariants,
          vehicleExtras,
          vehicleTrim,
          vehicleBodyPaint,
          vehicleRoofPaint,
          vehicleDriveawayPrice,
          {
            mode: vehicleFinanceSetting,
          }
        );

        if (vehicleFinanceSetting === "finance") {
          angular.extend(vehicleData, vehicleFinanceOptions);
        }

        return vehicleData;
      }

      function setGrade(gradeId) {
        if (!gradeId) {
          throw new Error(
            "PricingPageAnalyticsService: setGrade() requires a gradeId to be specified"
          );
        }

        var grade = Range.getGradeByIdFromCache(gradeId);

        if (!grade) {
          throw new Error(
            "PricingPageAnalyticsService: could not find grade with gradeId " +
              gradeId
          );
        }

        vehicleGrade = {
          vehicle_model: grade.vehicleModel?.Name
            ? grade.vehicleModel?.Name
            : null,
          vehicle_grade: grade.name ? grade.name : null,
        };
        vehicleVariants = {};
        vehicleExtras = {};
        vehicleTrim = {};
        vehicleBodyPaint = {};
        vehicleRoofPaint = {};
        vehicleDriveawayPrice = {};
        vehicleFinanceOptions = {};
      }

      function setVariant(variant) {
        vehicleVariants = {
          cab: variant.cab,
          cabChassis: variant.cabChassis,
          doors: variant.doors,
          vehicle_drive_type: variant.drivetrain ? variant.drivetrain : null,
          vehicle_engine_capacity: variant.engineType
            ? variant.engineType
            : null,
          seats: variant.seats,
          vehicle_transmission: variant.transmission
            ? variant.transmission
            : null,
        };
        vehicleExtras = {};
        vehicleTrim = {};
        vehicleBodyPaint = {};
        vehicleRoofPaint = {};
        vehicleDriveawayPrice = {};
        vehicleFinanceOptions = {};
      }

      function setExtras(extras) {
        // This strips out the HTML tags so the extras label stays clean
        var cleanExtras = extras.replace(/<[^>]*>/g, "");
        vehicleExtras = {
          extras: cleanExtras,
        };
        vehicleTrim = {};
        vehicleBodyPaint = {};
        vehicleRoofPaint = {};
        vehicleDriveawayPrice = {};
        vehicleFinanceOptions = {};
      }

      function setTrim(trim) {
        vehicleTrim = {
          vehicle_interior_colour: trim ? trim : null,
        };
        vehicleBodyPaint = {};
        vehicleRoofPaint = {};
        vehicleDriveawayPrice = {};
        vehicleFinanceOptions = {};
      }

      function setBodyPaint(bodyPaint) {
        vehicleBodyPaint = {
          vehicle_exterior_colour: bodyPaint ? bodyPaint : null,
        };
        vehicleRoofPaint = {};
        vehicleDriveawayPrice = {};
        vehicleFinanceOptions = {};
      }

      function setRoofPaint(roofPaint) {
        vehicleRoofPaint = {
          vehicle_roof_colour: roofPaint ? roofPaint : null,
        };
        vehicleDriveawayPrice = {};
        vehicleFinanceOptions = {};
      }

      function setFinanceSetting(setting) {
        vehicleFinanceSetting = setting;
      }

      function getFinanceSetting() {
        return vehicleFinanceSetting;
      }

      function setDriveawayPrice(price) {
        vehicleDriveawayPrice = {
          fullDriveaway: price,
        };
      }

      function setFinanceOptions(financeSettings) {
        vehicleFinanceOptions = {
          estimatedRepayments: financeSettings.estimatedRepayments,
          interestRate: financeSettings.interestRate,
          loanTerm: financeSettings.loanTerm,
          deposit: financeSettings.deposit,
          avgDistance: financeSettings.avgDistance,
          gfv: financeSettings.gfv,
        };
      }

      function triggerAnalytics(event, datalayerItem) {
        var analyticsData = angular.extend(
          {},
          getAllVehicleData(),
          datalayerItem
        );

        $analytics.eventTrack(event, analyticsData);
      }

      function triggerAnalyticsBatch(event, datalayerItem) {
        var analyticsData = angular.extend(
          {},
          event === "click_secondary_interaction" ? getAllVehicleData() : null,
          datalayerItem
        );

        setTimeout(() => {
          if (
            !window.analyticEventsBatch ||
            window.analyticEventsBatch.length == 0
          )
            return;
          for (
            var index = 0;
            index < window.analyticEventsBatch.length;
            index++
          ) {
            $analytics.eventTrack(
              window.analyticEventsBatch[index].event,
              window.analyticEventsBatch[index].analyticsData
            );
          }
          window.analyticEventsBatch = [];
        }, 900);

        if (window.analyticEventsBatch.length === 0) {
          window.analyticEventsBatch.push({
            event: event,
            analyticsData: analyticsData,
          });
        } else {
          var isFound = false;
          for (
            var index = 0;
            index < window.analyticEventsBatch.length;
            index++
          ) {
            if (window.analyticEventsBatch[index]?.event === event) {
              isFound = true;
              break;
            }
          }

          if (!isFound) {
            window.analyticEventsBatch.push({
              event: event,
              analyticsData: analyticsData,
            });
          }
        }
      }

      function pushToDataLayer(datalayerItem) {
        dataLayer.push(datalayerItem);
      }

      window.analyticEventsBatch = [];

      // Exports
      return {
        setGrade: setGrade,
        setVariant: setVariant,
        setExtras: setExtras,
        setTrim: setTrim,
        setBodyPaint: setBodyPaint,
        setRoofPaint: setRoofPaint,
        setFinanceSetting: setFinanceSetting,
        getFinanceSetting: getFinanceSetting,
        setDriveawayPrice: setDriveawayPrice,
        setFinanceOptions: setFinanceOptions,
        triggerAnalytics: triggerAnalytics,
        getAllVehicleData: getAllVehicleData,
        pushToDataLayer: pushToDataLayer,
        triggerAnalyticsBatch: triggerAnalyticsBatch,
      };
    },
  ]);
})(window.angular, window.dataLayer);
